import { useEffect } from "react";
import useSWR from "swr";
import { getAuthCookies } from "lib/utils/auth";
import { getRequest, staticOptions } from "lib/core/apiClient";
import { parseUserAddress, setUserOrderHistory } from "lib/utils/user";
import { useCheckoutContext } from "lib/contexts/CheckoutProvider";
import { useSearchParams } from "react-router-dom";
import { useUserContext } from "lib/contexts/UserProvider";
import { AddressConfigType } from "lib/contexts/MerchantProvider";

export const useUserAddress = ({
  checkoutId,
  merchantId,
  checkoutAddresses,
  isCheckoutLoading,
  addressConfig,
}: {
  checkoutId: string;
  merchantId: string;
  isCheckoutLoading: boolean;
  checkoutAddresses: {
    shipping_address_id?: string;
    billing_address_id?: string;
  };
  addressConfig?: AddressConfigType[];
}) => {
  const {
    state: { user },
    actions: { setUserAddress },
  } = useUserContext();

  const [searchParams] = useSearchParams();
  const page = searchParams.get("page")?.toLowerCase();
  const { data: addressResponse } = useSWR<
    {
      addresses: Record<string, any>[];
      uid: string;
    } | null,
    any,
    string
  >(
    "/gatekeeper/accounts?include=address",
    (url) => {
      const cookies = getAuthCookies();
      if (!cookies || (page && page !== "payment-status")) {
        return null;
      }
      return getRequest(url, "KRATOS_PRIVATE");
    },
    staticOptions,
  );
  // setting user address using checkout response and address response
  useEffect(() => {
    if (!isCheckoutLoading && checkoutId && addressResponse?.uid) {
      setUserAddress(checkoutAddresses, addressResponse?.addresses, false, addressConfig);
    }
  }, [
    checkoutId,
    addressResponse?.uid,
    isCheckoutLoading,
    checkoutAddresses?.shipping_address_id,
    checkoutAddresses?.billing_address_id,
  ]);
};
